/** Note: this is not necessarily the same as the features in current live app */
const islandMock = {
  type: 'island',
  feature_support: {
    cet: { version: 2 },
    createSticker: { version: 1 },
    nativeShare: { version: 1 },
    navigationVisibility: { version: 1 },
    navigate: {
      version: 1,
      paths: [
        '/invite'
      ]
    },
  },
  client_event_tracking: {},
  app_details: {
    app_version: '1234',
    os: 'iOS',
    theme: 'light'
  },
  user_details: {
    experiments: {
      // set to 'on' to show group sharing in generators/artifacts locally
      group_chat_IS_2943: 'on'
    }
  }
};

export default islandMock;
